// extracted by mini-css-extract-plugin
export var dataCell = "_q8-2";
export var dataRow = "_q8-0";
export var headerRow = "_q8-1";